import RatePlanCard from "./RatePlanCard";
import { TbTag } from "react-icons/tb";

const RatePlanGrid = ({ ratePlans, handleEdit, handleDelete }) => {
  if (ratePlans.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-20 gap-3">
        <div className="w-12 h-12 rounded-2xl bg-gray-100 flex items-center justify-center">
          <TbTag className="text-gray-300 text-2xl" />
        </div>
        <p className="text-sm font-semibold text-gray-400">Aucun tarif créé</p>
        <p className="text-xs text-gray-300">Créez votre premier plan tarifaire pour commencer</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-2 items-start">
      {ratePlans.map((plan) => (
        <RatePlanCard
          key={plan._id}
          plan={plan}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
        />
      ))}
    </div>
  );
};

export default RatePlanGrid;